/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import moment from "moment";
import { Box, Tooltip } from "@mui/material";
import { useDispatch } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import * as Sentry from "@sentry/react";
import { SERVICES } from "../../components/Layout/Services";
import { get } from "../../components/Layout/ApiHandler/apihandler";
import PageSyncCal from "../../components/Layout/PageSyncCal";
import Heading from "../../components/Layout/Heading/NewHeading";
import { OuterContainerStyles } from "../../components/Layout/Typography";
import GenericTable from "./MemberSearch/Components/GenericTable";
import ViewIcon from "../../components/Svg/ViewIcon";
import Loader from "../../components/Loader/Loader";
import { ROUTES } from "../../components/Routes";
import { updateSelectedContribution } from "../../Config/Redux/actions/updateContributionData";
import { setUserData } from "../../Config/Redux/actions/userActions";

const tableHeaders = [
  "Mode of Payment",
  "Amount",
  "Cheque/DD No.",
  "Contribution Date",
  "Payment Status",
  "Uin Type",
  "Uin",
  "Action",
];
const DEFAULT_PAGE_SIZE = 10;
function MemberContributionViewUpdate() {
  const [memberData, setMemberData] = useState({});
  const [paymentOrders, setPaymentOrders] = useState({});
  const [paymentData, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const { memberId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getUserProfile = async () => {
    try {
      setIsLoading(true);
      const url = `${SERVICES.GET_MEMBER}/${memberId}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setMemberData(data.data);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      } else {
        console.error("Failed to fetch Division Type data");
        setIsLoading(false);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    }
  };
  const getPaymentOrders = async () => {
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/paymentOrders?size=${DEFAULT_PAGE_SIZE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setPaymentOrders(data.data);
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handlePageChange = async (selectedPage) => {
    setIsLoading(true);
    setCurrentPage(selectedPage);
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/paymentOrders?page=${selectedPage}&size=${DEFAULT_PAGE_SIZE}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setPaymentOrders(data.data);
      } else {
        console.error("Failed to fetch contribution data");
        setIsLoading(false);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const handleViewReceipt = async (paymentOrderId) => {
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/paymentOrders/${paymentOrderId}/receipt`;
      const response = await get(url);

      if (response && response.ok) {
        // Handle the successful response as needed
        const receiptData = await response.json();
        // console.log("Receipt Data:", receiptData);
        const redirect = receiptData.data;
        if (redirect) {
          window.open(redirect, "_blank");
        }
      } else {
        console.error("Failed to fetch receipt data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  // const handleClick = (item) => {
  //   dispatch(updateSelectedContribution(item));
  //   navigate(`${ROUTES.MEMBER_CONTRIBUTION_UPDATE}/${memberId}/${item?.id}`);
  // };

  useEffect(() => {
    if (paymentOrders.content) {
      const updatedTableData = paymentOrders.content.map((item) => {
        // console.log(item);
        // console.log("line no 378", paymentOrders.content);
        const formattedDate = moment(item?.createdAt).format("DD/MM/YYYY");
        return {
          "Mode of Payment":
            item?.paymentTransaction?.paymentMethodType?.replace(/_/g, " "),
          Amount: item?.amount ? `${item.amount.toString()}.00` : "",
          "Cheque/DD No.":
            item?.paymentTransaction?.chequeNumber ??
            item?.paymentTransaction?.ddNumber ??
            "",
          "Contribution Date": formattedDate,
          "Payment Status": item?.status,
          "Uin Type": item?.uinType?.replace(/_/g, " "),
          Uin: item?.uin,
          Action: (
            // <Btn
            //   onClick={async () => {
            //     dispatch(setUserData(memberData));
            //     dispatch(updateSelectedContribution(item));
            //     await navigate(
            //       `${ROUTES.MEMBER_CONTRIBUTION_UPDATE}/${memberId}/${item?.id}`,
            //     );
            //   }}
            // >
            //   Update
            // </Btn>
            <Box sx={{ display: "flex", gap: "10px" }}>
              <Tooltip title="Update contribution" placement="top">
                <div>
                  <EditIcon
                    sx={{ fontSize: "medium", cursor: "pointer" }}
                    onClick={async () => {
                      dispatch(setUserData(memberData));
                      dispatch(updateSelectedContribution(item));
                      await navigate(
                        `${ROUTES.MEMBER_CONTRIBUTION_UPDATE}/${memberId}/${item?.id}`,
                      );
                    }}
                  />
                </div>
              </Tooltip>
              {item?.paymentTransaction?.receiptCancelledFlag === false && (
                <Tooltip title="View Receipt" placement="top">
                  <div>
                    <ViewIcon
                      style={{ cursor: "pointer", textAlign: "cenetr" }}
                      onClick={() => handleViewReceipt(item?.id)}
                    />
                  </div>
                </Tooltip>
              )}
              {/* <ViewIcon
                style={{ cursor: "pointer", textAlign: "cenetr" }}
                onClick={() => handleViewReceipt(item?.id)}
              /> */}
            </Box>
          ),
        };
      });

      setData(updatedTableData);
    }
  }, [paymentOrders.content]);
  useEffect(() => {
    getUserProfile();
    getPaymentOrders();
  }, [memberId]);
  // console.log(paymentOrders.totalElements);
  //   return <div>{memberData.fullName}</div>;
  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <PageSyncCal />
      <Heading title="Contribution Details" />
      <OuterContainerStyles
        marginTop="24px"
        marginBottom="24px"
        style={{ padding: "24px" }}
      >
        <OuterCard>
          <Box sx={{ padding: "12px 0px" }}>
            <OuterCardHeading fontSize="18px" fontWeight="500">
              {/* Organization Structure */}
              Previous Contribution
            </OuterCardHeading>
          </Box>
          {/* <OuterCardText>
            Delhi - East / Noida - Vasundhara / Mayur Vihar Phase 3 / Bharti
            Successors / Vardhman 2 / Block 2
          </OuterCardText> */}
          {/* <OuterCardText>
            {`${memberData.areaName || "NA"} / ${
              memberData.zoneName || "NA"
            } / ${memberData.regionName || "NA"} / ${
              memberData.chapterName || "NA"
            } / ${memberData.districtName || "NA"} / ${
              memberData.blockName || "NA"
            }`}
          </OuterCardText> */}
        </OuterCard>
        <OuterCard style={{ marginTop: "24px" }}>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Member Details
          </OuterCardHeading>
          <TotalContributionText>
            Total number of contribution made : {paymentOrders?.totalElements}
          </TotalContributionText>
          <MemberDetailsDiv largePadding>
            <MemberDetailsTextHeading>Member Name</MemberDetailsTextHeading>
            <MemberDetailsText>{memberData.fullName}</MemberDetailsText>
          </MemberDetailsDiv>
          <MemberDetailsDiv2>
            <MemberDetailsTextHeading>Address</MemberDetailsTextHeading>
            <MemberDetailsText>{memberData.addressLine1}</MemberDetailsText>
          </MemberDetailsDiv2>
          <MemberDetailsDiv>
            <MemberDetailsTextHeading>Contact Info</MemberDetailsTextHeading>
            <MemberDetailsText>
              {`${memberData.emailId}  /  ${memberData.mobileNumber}`}
            </MemberDetailsText>
          </MemberDetailsDiv>
          <MemberDetailsDiv2>
            <MemberDetailsTextHeading>
              {/* Contribution Collection to Deposit */}
              Organization Structure
            </MemberDetailsTextHeading>
            <MemberDetailsTextForOrg>
              {`${memberData.areaName || "NA"} / ${
                memberData.zoneName || "NA"
              } / ${memberData.regionName || "NA"} / ${
                memberData.chapterName || "NA"
              } / ${memberData.districtName || "NA"} / ${
                memberData.blockName || "NA"
              }`}
            </MemberDetailsTextForOrg>
          </MemberDetailsDiv2>
          {/* <MemberDetailsDiv largePadding>
            <MemberDetailsTextHeading>Gohonzon Member</MemberDetailsTextHeading>
            <MemberDetailsText>
              {" "}
              {memberData.gohonzonMemberships &&
              memberData.gohonzonMemberships.length > 0
                ? memberData.gohonzonMemberships[0].type
                : "No"}
            </MemberDetailsText>
          </MemberDetailsDiv> */}
          <MemberDetailsDiv largePadding>
            <MemberDetailsTextHeading>
              Division/Sub Division
            </MemberDetailsTextHeading>
            <MemberDetailsText> {memberData?.divisionName}</MemberDetailsText>
          </MemberDetailsDiv>
          {/* <MemberDetailsDiv largePadding>
            <MemberDetailsTextHeading>
              Contribution Collection to Deposit
            </MemberDetailsTextHeading>
            <MemberDetailsText>Yes Bank</MemberDetailsText>
          </MemberDetailsDiv> */}
          {paymentData.length > 0 ? (
            <Box sx={{ width: "100%", marginTop: "32px" }}>
              <GenericTable
                tableData={paymentData}
                data={paymentOrders}
                headers={tableHeaders}
                onPageChange={handlePageChange}
              />
            </Box>
          ) : (
            // <p>Empty Data</p>
            <NodataText>No existing contribution details found.</NodataText>
          )}
        </OuterCard>
        {/* <Box sx={{ padding: "24px" }}>
          <CardContainer>
            <CardHeader>
              <h3>{memberData.fullName}</h3>
            </CardHeader>
            <CardContent>
              <Label>Address:</Label>
              <p>{memberData.addressLine1}</p>

              <Label>Contact Info:</Label>
              <p>{`${memberData.emailId} / ${memberData.mobileNumber}`}</p>

              <Label>Organization Structure:</Label>
              <p>NA</p>
            </CardContent>
          </CardContainer>
        </Box> */}
        {/* <Box sx={{ padding: "24px" }}>
          <GenericTable
            tableData={paymentData}
            data={paymentOrders}
            headers={tableHeaders}
            onPageChange={handlePageChange}
          />
        </Box> */}
        {/* <OuterCard style={{ marginTop: "24px" }}>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Existing Contribution Details
          </OuterCardHeading>
          {paymentData.length > 0 ? (
            <Box sx={{ width: "100%" }}>
              <GenericTable
                tableData={paymentData}
                data={paymentOrders}
                headers={tableHeaders}
                onPageChange={handlePageChange}
              />
            </Box>
          ) : (
            // <p>Empty Data</p>
            <NodataText>No existing contribution details found.</NodataText>
          )}
        </OuterCard> */}
        {isLoading && <Loader />}
      </OuterContainerStyles>
    </div>
  );
}

export default MemberContributionViewUpdate;

const OuterCard = styled.div`
  display: flex;
  padding: 12px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #c5c5d1;
  background: #f5f5f5;
`;

const OuterCardHeading = styled.p`
  margin: 0;
  color: #000;
  //   font-family: Noto Sans;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
const OuterCardText = styled.p`
  margin: 0;
  color: #484848;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

const MemberDetailsDiv = styled.div`
  display: flex;
  padding: ${(props) => (props.largePadding ? "16px" : "7px")} 24px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border: 1px solid #62b6da;
  background: #fff;
`;
const MemberDetailsDiv2 = styled.div`
  display: flex;
  padding: 7px 24px;
  // padding: 16px 24px;
  padding: ${(props) => (props.largePadding ? "16px" : "7px")} 24px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border: 1px solid #62b6da;
  background: #e8f6fc;
`;

const MemberDetailsTextHeading = styled.p`
  margin: 0;
  width: 250px;
  color: #484848;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
`;
const MemberDetailsText = styled.p`
  margin: 0;
  width: 270px;
  color: #484848;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
`;
const MemberDetailsTextForOrg = styled.p`
  margin: 0;
  width: 345px;
  color: #484848;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
`;
const NodataText = styled.p`
  color: #e41717;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
`;
const Btn = styled.button`
  border: none;
  background-color: transparent;
  color: #00adf8;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
`;
// const CardContainer = styled.div`
//   border: 1px solid #ddd;
//   border-radius: 8px;
//   overflow: hidden;
//   // width: 300px;
//   // width: 100%;
//   height: 20%;
//   // margin: 24px;
//   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
// `;

// const CardHeader = styled.div`
//   background-color: #f1f1f1;
//   padding: 10px;
//   text-align: center;
// `;

// const CardContent = styled.div`
//   padding: 20px;
// `;

// const Label = styled.div`
//   font-weight: bold;
//   margin-bottom: 5px;
// `;
const TotalContributionText = styled.p`
  margin: 0;
  color: #8b8b8b;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
